import { baseApi } from 'services'

import { setDealAdvisorOpen, setDealAdvisorTab } from '@/client/generalSlice'

/**
 * This is the API for the UI Preferences.
 * It is used to store the user's UI preferences in the backend across sessions.
 */
export const uiPreferencesApi = baseApi
  .enhanceEndpoints({
    endpoints: {
      /**
       * To avoid bloating the getLoggedUser endpoint with a ton of UI Settings,
       * we are enhancing the endpoint instead.
       * @see operations-frontend/src/services/user.ts
       */
      getLoggedUser: {
        onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
          const resp = await queryFulfilled

          if (typeof window !== 'undefined') {
            const isWorkViewsPage =
              window.location.pathname.endsWith('work-views-pipeline') ||
              window.location.pathname.endsWith('work-views')
            if (isWorkViewsPage) {
              dispatch(setDealAdvisorOpen(false))
            } else {
              // Update the state with the user preferences from the backend
              dispatch(setDealAdvisorTab(resp?.data.data.ui_preferences?.dealAdvisorTab ?? ''))
              dispatch(setDealAdvisorOpen(resp?.data.data.ui_preferences?.dealAdvisorOpen ?? false))
            }
          }
        },
      },
    },
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      /**
       * Use this endpoint to update the user's UI preferences in the backend.
       */
      patchUserPreferences: builder.mutation<void, Record<string, unknown>>({
        query: ({ id, ui_preferences }) => ({
          url: `v2/user/${id}/`,
          method: 'PATCH',
          body: { data: { ui_preferences } },
        }),
      }),
    }),
  })

export const { usePatchUserPreferencesMutation } = uiPreferencesApi
